export const MARKETING_CAMPAIGNS_TABLE = '/subscribers/campaigns';
export const MARKETING_CAMPAIGN = '/subscribers/campaigns/:id';
export const MARKETING_CAMPAIGN_DELETE = '/subscribers/campaigns/:id';

export const MARKETING_CAMPAIGN_TARGETS = '/subscribers/campaigns/targets';
export const MARKETING_CAMPAIGN_TARGETS_MASS_DELETE =
	'/subscribers/campaigns/targets/campaign/:id/massDelete';
